import React from 'react'
import styled from 'styled-components'
import media from '../../styles/media'

//Components
import CustomModal from '../container/modal/modal'
import Icon from '../icon/icon'

const Title = styled.p`
  font-size: 26px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  margin: 0 0 20px 0;
  ${media.md`
    font-size: 40px;
  `};
`

const Intro = styled.p`
  font-size: 10px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.54;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  margin: 0 0 30px 0;
  ${media.md`
    font-size: 13px;
  `};
`

const Button = styled.button`
  &.btn {
    padding: 1rem 2.1rem;
    border-radius: 0;
    line-height: normal;
    background-color: #ffffff;
    border-color: white;
  }
  display: block;
  text-decoration: none;
  cursor: pointer;
  background-color: #ffffff;
  &:hover {
    background-color: #40b4e4;
  }
`
const TextButton = styled.span`
  font-size: 0.9rem;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 3px;
  text-align: center;
  color: #3c4252;
  @media (max-width: 768px) {
    font-size: 10px;
  }
`

const StyledIcon = styled(Icon)`
  width: 7rem;
  height: 3rem;
`

function Welcome({ isOpen, _closeWelcome }) {
  return (
    <CustomModal isOpen={isOpen}>
      <div className="container">
        <div className="row">
          <div className="col-md-6 offset-md-3">
            <div className="d-flex justify-content-center mb-4">
              <StyledIcon name={'logo-ppm-alone'} fill={'white'} />
            </div>
            <div className="mb-4">
              <Title>Digitaliza. Innova. Fideliza.</Title>
            </div>
            <div className="mb-4">
              <Intro>
                Nuestras líneas de negocio forman parte de un conjunto integral
                de soluciones que preparan a nuestros clientes para poder
                enfrentar los desafíos en la era digital.
              </Intro>
            </div>

            <div className="d-flex justify-content-center">
              <Button className="btn" onClick={() => _closeWelcome()}>
                <TextButton>EXPLORAR</TextButton>
              </Button>
            </div>
          </div>
        </div>
        {/* 
         */}
      </div>
    </CustomModal>
  )
}

export default Welcome



// WEBPACK FOOTER //
// ./src/components/welcome/Welcome.js